import { useEffect } from 'react';
import { getUserManager } from '@components/Auth/manager';

export const useAuth0LoginRedirect = () => {
  const getOidcState = () => {
    const redirectPathParam = 'redirectPath=';
    const queryString = window.location.search;
    const redirectPathParamStartIndex = queryString.indexOf(redirectPathParam);
    if (redirectPathParamStartIndex < 0) {
      return '/';
    }
    const redirectPathParamEndIndex = queryString.indexOf('&', redirectPathParamStartIndex);
    return decodeURIComponent(
      queryString.slice(
        redirectPathParamStartIndex + redirectPathParam.length,
        redirectPathParamEndIndex >= 0 ? redirectPathParamEndIndex : undefined
      )
    );
  };

  useEffect(() => {
    const userManager = getUserManager();
    userManager.signinRedirect({ state: getOidcState() });
  }, []);
};
